import { render, staticRenderFns } from "./SettingLeave.vue?vue&type=template&id=e8e9f626&"
import script from "./SettingLeave.vue?vue&type=script&lang=js&"
export * from "./SettingLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports